import { Button } from '@/components/form/Button';
import { useCreateCompanyContract } from '@/services/api/hooks/companies';
import { useCompanyId, usePartnerId } from '@/services/authentication/hooks/user';
import { motion } from 'framer-motion';
import { FC, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DecorativeSplit } from '../../../layouts/DecorativeSplit';
import { Account } from '../../../layouts/header/Account';
import { PageTitle } from '../../../utils/Title';
import { SigningEvents } from '../commonSteps/signingEvents';

export const CompanyOnboardingNdaSigned: FC = () => {
  const [queryParameters] = useSearchParams();
  const event = queryParameters.get('event');

  const success = event !== SigningEvents.DECLINED;

  const partnerId = usePartnerId();
  const companyId = useCompanyId();

  if (!partnerId || !companyId) {
    throw Error('Partner ID and Company ID must be provided');
  }

  const createContract = useCreateCompanyContract(partnerId, companyId);

  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const result = await createContract.mutateAsync({});
    setLoading(false);

    if (result.viewUrl) {
      window.location.replace(result.viewUrl);
    }
  };

  const errorObj = createContract.error as Error | undefined;
  const error = errorObj ? errorObj.message : '';

  return (
    <>
      <PageTitle>Company Onboarding</PageTitle>
      <DecorativeSplit className="my-12">
        <div className="border-secondary-std flex justify-end border-b py-4">
          <motion.div layoutId="account">
            <Account />
          </motion.div>
        </div>
        <div className="mt-8">
          {!success ? (
            <div>An issue occured while signing the NDA. Please contact DaaS to resolve this issue.</div>
          ) : (
            <div className="space-y-5">
              <div className="text-lg">Thank you for signing our NDA.</div>
              <div>Now please return to Docusign to sign our Terms & Conditions.</div>
              {error && <p className="text-red-500 mt-2">{error}</p>}
              <Button loading={loading} onClick={onClick}>
                Sign Terms & Conditions
              </Button>
            </div>
          )}
        </div>
      </DecorativeSplit>
    </>
  );
};
